<template>
  <div class="common-title-page run-page">
    <div class="title-wrapper">
      <span class="title">{{ $t('text.product_characterisation_run') }}</span>
      <div class="text-right">
        <UtcOffsets />
      </div>
    </div>
    <RunInit
      ref="runInit"
      v-show="!haveInit"
      :utcOffset="$store.state.pods.selectedUtcOffset"
    />
    <RunContinue
      ref="runContinue"
      v-show="haveInit"
      :utcOffset="$store.state.pods.selectedUtcOffset"
    />
  </div>
</template>

<script>
import RunInit from '@/components/products/characterisation/RunInit'
import RunContinue from '@/components/products/characterisation/RunContinue'
import UtcOffsets from '@/components/UtcOffsets'
export default {
  data() {
    return {
      haveInit: false
    }
  },
  components: {
    RunInit,
    RunContinue,
    UtcOffsets
  }
}
</script>
